module.exports = __webpack_public_path__ + "img/wood.fbd93a5a.png";